import React from 'react';
import styles from './CasesCheckList.module.css';

// Services
import { getFullName } from '../../../services/getPatientAtribute';

// Context
import PatientsContext from '../../../context/PatientsContext';

// Hooks
import { useContext, useState } from 'react';

// Components
// import SliderCheckbox from '../SliderCheckbox/SliderCheckbox';
import Searchbar from '../Searchbar/Searchbar';
import CheckboxButton from '../CheckboxButton/CheckboxButton';

// Language
import { useTranslation } from 'react-i18next';

// Interfaces
import { Case, Patient } from '../../../interfaces/Patient';
interface CaseWithPatient {
    case: Case;
    patientId: number;
    patientName: string;
}

const CasesCheckList: React.FC<{
    label: string,
    casesLinked: number[],
    casesBlocked?: number[],
    casesToShow?: number[],
    searchbar: boolean,
    handleClickCheckbox: (case_id: number, pid: number) => void
}> = ({ label, casesLinked, casesBlocked, casesToShow, searchbar, handleClickCheckbox }) => {

    const { t } = useTranslation();

    const { patients } = useContext(PatientsContext);

    const cases = patients.flatMap(p => {
        return p.cases.map(c => ({
            case: c,
            patientId: p.id,
            patientName: getFullName(p)
        }));
    });

    //console.log(cases)

    const [filterSearchbar, setFilterSearchbar] = useState<(patient: CaseWithPatient) => boolean>(() => () => true);

    const casesFiltered = casesToShow ?
        cases.filter(caso => casesToShow.includes(caso.case.id) && filterSearchbar(caso)) :
        cases.filter(caso => filterSearchbar(caso));

    const handleChangeSearchbar = (evt: React.ChangeEvent<HTMLInputElement>) => {
        setFilterSearchbar(() => (caso: CaseWithPatient) =>
            caso.patientName.toLowerCase().includes(evt.target.value.toLowerCase())
            || Boolean(caso.case.hospital_case?.toLocaleLowerCase()?.includes(evt.target.value.toLocaleLowerCase()))
        );
    };

    return (
        <>
            <div className={styles.pollAssignedTitle}>
                <h3>{label}</h3>
            </div>
            {searchbar && <div className={styles.searchbarContainer}>
                <Searchbar handleChange={handleChangeSearchbar} placeholder={t('search_by_name_or_NHC') as string} />
            </div>}
            <div className={styles.patientsChecklistContainer} >
                {casesFiltered.map(caso =>
                    <CheckboxButton
                        key={caso.case.id}
                        checked={casesLinked.includes(caso.case.id)}
                        onClick={(checked: boolean) => handleClickCheckbox(caso.case.id, caso.patientId)}
                        label={(caso.case.hospital_case ?? '') + ' - ' + caso.patientName}
                        disabled={casesBlocked?.includes(caso.case.id)}
                    />
                )}
            </div >
        </>
    );
};

export default CasesCheckList;